export default __webpack_public_path__ + "static/media/calgarytower.82478b09.webp";